module.exports = __webpack_public_path__ + "static/media/green-logo.b5bf6d0c.svg";